import React, { useEffect, useMemo, useRef, useState } from "react";
import "./ResidentialComplexList.css";

export default function ComplexesToolbar({
  viewTab = true,
  activeTab = "Список ЖК",
  listTabLabel = "Список ЖК",
  searchPlaceholder = "Поиск по устройствам, квартирам, приборным данным...",
  onTabChange,
  onExport,
  onSearch,
  onFilter,
  exportDisabled = false,
  exportLoading = false,
  searchEnabled = false,
  searchValue = '',
  onSearchChange,
  onSearchToggle,
  actionsPrefix = null,
}) {
  const TABS = useMemo(
    () => [
      listTabLabel,
      "Карта объектов",
      "Проблемы",
      "Список УСПД",
      "Отчёты",
      "Статистика",
    ],
    [listTabLabel]
  );
  const [searchOpen, setSearchOpen] = useState(false);
  const [value, setValue] = useState(searchValue || '');
  const inputRef = useRef(null);

  useEffect(() => {
    if (searchOpen) {
      setValue(searchValue || '');
      inputRef.current?.focus();
    }
  }, [searchOpen, searchValue]);

  useEffect(() => {
    onSearchToggle?.(searchOpen);
    if (!searchOpen) {
      setValue('');
    }
  }, [searchOpen]);

  const submit = () => {
    onSearchChange?.(value.trim());
  };

  const cancel = () => {
    setSearchOpen(false);
    setValue('');
    onSearchChange?.('');
  };

  return (
    <div className="rc-toolbar">
      {viewTab && !(searchEnabled && searchOpen) && (
        <div className="rc-tabs">
          {TABS.map((t) => (
            <button
              key={t}
              className={`rc-tab ${activeTab === t ? "is-active" : ""}`}
              onClick={() => onTabChange?.(t)}
              type="button"
            >
              {t}
            </button>
          ))}
        </div>
      )}

      <div className={`rc-actions ${searchEnabled && searchOpen ? 'rc-actions--search' : ''}`}>
        {searchEnabled && searchOpen ? (
          <div className="rc-search-inline">
            <input
              ref={inputRef}
              className="rc-search-input"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') submit();
                if (e.key === 'Escape') cancel();
              }}
              placeholder={searchPlaceholder}
            />
            <div className="rc-search-buttons">
              <button type="button" className="rc-btn" onClick={submit}>
                Найти
              </button>
              <button type="button" className="rc-btn" onClick={cancel}>
                Отмена
              </button>
            </div>
          </div>
        ) : (
          <>
            {searchEnabled ? (
              <button type="button" className="rc-btn" onClick={() => setSearchOpen(true)}>
                Поиск
              </button>
            ) : (
              <button type="button" className="rc-btn" onClick={onSearch}>
                Поиск
              </button>
            )}
            <button
              type="button"
              className="rc-btn"
              onClick={onExport}
              disabled={exportDisabled || exportLoading}
            >
              {exportLoading ? "Формируем..." : (<>
                Выгрузить в Excel <span className="rc-kbd">⌘</span>
              </>)}
            </button>
            <button type="button" className="rc-btn" onClick={onFilter}>
              Фильтр
            </button>
            {actionsPrefix}
          </>
        )}
      </div>
    </div>
  );
}
